import { CollectionUtils } from "./collectionUtils";

const processCustomCollection = async (customCollection) => {
  const collectionList = await CollectionUtils.getChartCollections();

  const collectionMap = generateMapByProperty(
    customCollection.selectedCharts,
    "chart_collection_id"
  );

  const collectionIds = Object.keys(collectionMap);

  const chartLists = await Promise.all(
    collectionIds.map(async (collectionId) => {
      const collection = collectionList.find(
        (collection) => collection.id === collectionId
      );

      const chartList = await CollectionUtils.getChartList(collection);

      const flattenedChartList = flattenChartList(chartList);

      const chartListWithCollection = flattenedChartList.map((chart) => ({
        ...chart,
        collection,
      }));

      return chartListWithCollection;
    })
  );

  const aggregatedChartList = collectionIds.reduce(
    (acc, collectionId, index) => {
      const relevantChartList = chartLists[index];
      const relevantChartIds = collectionMap[collectionId];
      const relevantSubsetChartList = relevantChartList.filter((chart) =>
        relevantChartIds.includes(chart.id)
      );

      return [...acc, ...relevantSubsetChartList];
    },
    []
  );

  const groupedAggregatedChartList = groupChartList(aggregatedChartList);

  return groupedAggregatedChartList;
};

const generateMapByProperty = (list, property) => {
  const map = {};
  list.forEach((item) => {
    const id = item[property];
    map[id] = map[id] ? [...map[id], item.id] : [item.id];
  });
  return map;
};

const flattenChartList = (chartList) => {
  const result = [];

  chartList.forEach((chartData) => {
    const { name, marketCap } = chartData;
    chartData.charts.forEach((chart) => {
      result.push({ ...chart, name, marketCap });
    });
  });

  return result;
};

// Inverse of flattenChartList function
const groupChartList = (flattenedChartList) => {
  const result = [];

  flattenedChartList.forEach((chart) => {
    const index = result.findIndex(
      (resultChart) => resultChart.name === chart.name
    );
    const chartToAdd = { ...chart };
    delete chartToAdd.name;
    delete chartToAdd.marketCap;
    delete chartToAdd.collection;

    if (index > -1) {
      result[index].charts.push(chartToAdd);
    } else {
      result.push({
        name: chart.name,
        marketCap: chart.marketCap,
        collection: chart.collection,
        charts: [chartToAdd],
      });
    }
  });

  return result;
};

export default processCustomCollection;
